import {
    postVerifyEmailOtpReducer,
} from '../../slices/gq-svc-pp';

export const gqSvcPpEmailReducers = {
    postVerifyEmailOtp: postVerifyEmailOtpReducer,
};